import { coreApi } from '$api'
import { IThirdPartyContact } from '$models'
import { getActiveCompanySettings, singletonQueryClient } from '$utils'

enum QueryKeys {
  getThirdPartyContacts = 'getThirdPartyContacts',
}

/**
 * Retrieves all third party contacts
 * @returns an list of third party contacts
 */
export const getThirdPartyContacts = async (
  system: string
): Promise<IThirdPartyContact[]> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return []

  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.getThirdPartyContacts, { system }],
    queryFn: async () => {
      return await coreApi.getThirdPartyContacts(system)
    },
  })
}
